module.exports = __webpack_public_path__ + "fonts/quicksand-latin-500-normal.de711eb.woff";